import ServiceDeskResquestService from '@/api/servicedesk'
import { SERVICE_DESK } from '../types'
import utils from '@/utils/utils.js'
import Vue from 'vue'
import i18n from '@/i18n'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    requests: [],
    date: null,
    types: [],
    serviceDeskTypes: []
  },
  getters: {
    date (state) {
      return state.date ? state.date : proto.$moment()
    },
    isPresentDay (state, getters) {
      return utils.isPresentDay(getters.date)
    }
  },
  mutations: {
    [SERVICE_DESK.SET_REQUESTS] (state, result) {
        state.requests = result
    },
    [SERVICE_DESK.SET_DATE] (state, value) {
      state.date = null
      state.date = value
    },
    [SERVICE_DESK.SET_SERVICE_DESK_TYPE] (state, result){
      state.types = result
    },
    [SERVICE_DESK.SET_TYPES] (state, serviceDeskTypes){
      state.serviceDeskTypes = serviceDeskTypes
    }
  },
  actions: {
    getRequests: function ({commit, dispatch, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      const date = getters.date.utc().format()
      return new Promise((resolve, reject) => {
        ServiceDeskResquestService.getRequests(date).then((response) => {
          commit(SERVICE_DESK.SET_REQUESTS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getServiceDeskType: function ({commit, dispatch}){
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        ServiceDeskResquestService.getServiceDeskType().then((response) => {
          commit(SERVICE_DESK.SET_SERVICE_DESK_TYPE, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    setDate ({ commit }, value) {
      commit(SERVICE_DESK.SET_DATE, value)
    },
    getServiceDeskTypes: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        ServiceDeskResquestService.getServiceDeskTypes().then((response) => {
          let serviceDesTypeWithTranslate = [];
          response.data.map((type) =>
          {
            serviceDesTypeWithTranslate.push({
              active: type.active,
              behavior: type.behavior,
              id: type.id,
              key: type.key,
              order: type.order,
              whatsAppNumber: type.whatsAppNumber,
              translateKey: i18n.t(type.key)
            })
          })
          serviceDesTypeWithTranslate =
            serviceDesTypeWithTranslate.sort(utils.sortByKey('translateKey'))
          commit(SERVICE_DESK.SET_TYPES, serviceDesTypeWithTranslate)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    async addServiceDeskType ({dispatch}, serviceDeskType) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await ServiceDeskResquestService.addServiceDeskType(serviceDeskType)
        await dispatch('getServiceDeskTypes')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editServiceDeskType ({dispatch}, serviceDeskType) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await ServiceDeskResquestService.editServiceDeskType(serviceDeskType)
        await dispatch('getServiceDeskTypes')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    activateServiceDeskType: function (_, typeId) {
      return new Promise((resolve, reject) => {
        ServiceDeskResquestService.activateServiceDeskType(typeId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateServiceDeskType: function (_, typeId) {
      return new Promise((resolve, reject) => {
        ServiceDeskResquestService.deactivateServiceDeskType(typeId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
  }
}
